import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import './faq-card.scss'

const FaqCard = ({ info, title, isActiveCard, setActiveCard }) => {
	const options = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, next) => (
				<p className='f-p f-faqcard-text'>{next}</p>
			),
		},
	}
	// const [isActiveCard, setActiveCard] = React.useState(false);
	return (
		<div className='f-faqcard-wrapper'>
			<div className='f-faqcard-container'>
				<div
					onClick={setActiveCard}
					className={`f-faqcard-header ${
						isActiveCard ? 'f-faqcard-header--active' : ''
					}`}
				>
					<h4 className='f-faqcard-title'>{title}</h4>
					<div className='f-button-container'>
						<button
							className={`f-faqcard-button ${
								isActiveCard ? 'f-faqcard-button--active' : ''
							}`}
						/>
					</div>
				</div>
				<div
					className={`f-faqcard-body ${
						isActiveCard ? 'f-faqcard-body--active' : ''
					}`}
				>
					{documentToReactComponents(info, options)}
				</div>
			</div>
		</div>
	)
}
export default FaqCard
